import { connectApi } from "@api/coreApi";
import { baseURL } from "@api/endpoints";

export const loginAccess = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.loginAccess,
    payload,
  });

export const getLinkedSA = ({ email }) =>
  connectApi({
    method: "GET",
    url: `${baseURL.getLinkedSA}?email=${email}`,
  });

export const clubsLoginOTP = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.clubsLoginOTP,
    payload,
  });

export const sendOTPCode = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.sendOTPCode,
    payload,
  });

export const verificationOTP = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.verificationOTP,
    payload,
  });
  
export const forgetPassword = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.forgetPassword,
    payload,
  });

export const resetPassword = (payload) =>
  connectApi({
    method: "POST",
    url: baseURL.resetPassword,
    payload,
  });
